// src/__internal__/plugins/usePlugins.ts
import { useContext } from "react";
import { PluginsContext } from "./PluginsProvider.mjs";
function usePlugins() {
  return useContext(PluginsContext);
}
export {
  usePlugins
};
